import "@/App.css";
import { useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { SubscriptionProvider } from "@/context/SubscriptionContext";
import ScrollToTop from "@/components/ScrollToTop";
import InstallPrompt from "@/components/InstallPrompt";
import PushNotificationManager from "@/components/PushNotificationManager";
import TrialBanner from "@/components/TrialBanner";
import PromoBanner from "@/components/PromoBanner";
import ContentGate from "@/components/ContentGate";
import Navbar from "@/components/Navbar";
import Sidebar from "@/components/Sidebar";
import Footer from "@/components/Footer";
import HomePage from "@/pages/HomePage";
import ArticlePage from "@/pages/ArticlePage";
import SubmitTipPage from "@/pages/SubmitTipPage";
import LoginPage from "@/pages/LoginPage";
import RegisterPage from "@/pages/RegisterPage";
import ForgotPasswordPage from "@/pages/ForgotPasswordPage";
import ResetPasswordPage from "@/pages/ResetPasswordPage";
import SearchPage from "@/pages/SearchPage";
import AdminPage from "@/pages/AdminPage";
import ComparePage from "@/pages/ComparePage";
import DonatePage from "@/pages/DonatePage";
import DonateSuccessPage from "@/pages/DonateSuccessPage";
import ShopPage from "@/pages/ShopPage";
import SubscribePage from "@/pages/SubscribePage";
import SubscriptionSuccessPage from "@/pages/SubscriptionSuccessPage";
import SettingsPage from "@/pages/SettingsPage";
import ReferralPage from "@/pages/ReferralPage";
import ElectionsPage from "@/pages/ElectionsPage";
import CouncilDetailPage from "@/pages/CouncilDetailPage";
import ReadingListPage from "@/pages/ReadingListPage";
import PollsPage from "@/pages/PollsPage";
import MapPage from "@/pages/MapPage";
import PoliticiansPage from "@/pages/PoliticiansPage";
import PoliticianProfilePage from "@/pages/PoliticianProfilePage";
import AIResearchPage from "@/pages/AIResearchPage";
import WatchlistPage from "@/pages/WatchlistPage";
import ElectionOddsPage from "@/pages/ElectionOddsPage";
import CouncillorOddsPage from "@/pages/CouncillorOddsPage";
import HistoricalElectionsPage from "@/pages/HistoricalElectionsPage";
import ShareConstituencyPage from "@/pages/ShareConstituencyPage";
import TrendingPage from "@/pages/TrendingPage";
import MPExpensesPage from "@/pages/MPExpensesPage";

function App() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  
  return (
    <AuthProvider>
      <SubscriptionProvider>
        <BrowserRouter>
          <ScrollToTop />
          <div className="min-h-screen flex flex-col overflow-x-hidden">
            {/* Mobile Sidebar */}
            <Sidebar isOpen={sidebarOpen} onToggle={setSidebarOpen} />
            
            {/* Main Content */}
            <div className="flex-1 flex flex-col">
              <PromoBanner />
              <Navbar onMenuClick={() => setSidebarOpen(true)} />
              <TrialBanner />
              <main className="flex-1 pb-0">
                <Routes>
                  <Route path="/" element={<HomePage />} />
                  <Route path="/article/:id" element={<ArticlePage />} />
                  <Route path="/submit-tip" element={<SubmitTipPage />} />
                  <Route path="/login" element={<LoginPage />} />
                  <Route path="/register" element={<RegisterPage />} />
                  <Route path="/forgot-password" element={<ForgotPasswordPage />} />
                  <Route path="/reset-password" element={<ResetPasswordPage />} />
                  <Route path="/search" element={<SearchPage />} />
                  <Route path="/admin" element={<AdminPage />} />
                  <Route path="/compare" element={<ComparePage />} />
                  <Route path="/elections" element={<ElectionsPage />} />
                  <Route path="/council/:councilName" element={<CouncilDetailPage />} />
                  <Route path="/reading-list" element={<ReadingListPage />} />
                  <Route path="/polls" element={<PollsPage />} />
                  <Route path="/map" element={<MapPage />} />
                  <Route path="/politicians" element={<PoliticiansPage />} />
                  <Route path="/politician/:slug" element={<PoliticianProfilePage />} />
                  <Route path="/ai-research" element={<AIResearchPage />} />
                  <Route path="/watchlist" element={<WatchlistPage />} />
                  <Route path="/donate" element={<DonatePage />} />
                  <Route path="/donate/success" element={<DonateSuccessPage />} />
                  <Route path="/donate/cancel" element={<DonatePage />} />
                  <Route path="/shop" element={<ShopPage />} />
                  <Route path="/subscribe" element={<SubscribePage />} />
                  <Route path="/subscription/success" element={<SubscriptionSuccessPage />} />
                  <Route path="/subscription/cancel" element={<SubscribePage />} />
                  <Route path="/settings" element={<SettingsPage />} />
                  <Route path="/referral" element={<ReferralPage />} />
                  <Route path="/odds" element={<ElectionOddsPage />} />
                  <Route path="/council-odds" element={<CouncillorOddsPage />} />
                  <Route path="/election-history" element={<HistoricalElectionsPage />} />
                  <Route path="/share" element={<ShareConstituencyPage />} />
                  <Route path="/trending" element={<TrendingPage />} />
                  <Route path="/mp-expenses" element={<MPExpensesPage />} />
                </Routes>
              </main>
              <Footer />
              <ContentGate />
            </div>
          </div>
          <InstallPrompt />
          <PushNotificationManager />
          <Toaster position="top-center" />
        </BrowserRouter>
      </SubscriptionProvider>
    </AuthProvider>
  );
}

export default App;
